import { activityHistoryFiltersSlice } from "../../slice";

export const { addUpFilters } = activityHistoryFiltersSlice.actions;
